import lrCount from './_src/lrCount.vue'

lrCount.install = function(Vue) {
  Vue.component(lrCount.name, lrCount)
}

export default lrCount
